module.exports = __webpack_public_path__ + "static/media/dark-motion-leo-station-keeping.12dcb6d.mp4";